module.exports = __webpack_public_path__ + "static/img-serv-deploy-d96d32782f0f8e5df654c2a1c0965808.jpg";